<script setup>
import {onMounted, ref} from 'vue'

const model = defineModel()

const scrollY = ref(0)
const wrapper = ref(null)
watch(model, () => {
  scrollToView()
})
onMounted(() => {
  scrollToView()
})

async function scrollToView() {
  //window.innerHeight 740px actuall client height of viewable window
  await nextTick()
  const body = document.querySelector('body')
  const html = document.querySelector('html')
  const wrapperElementHeight = wrapper?.value?.clientHeight // 100px
  const topAndBottomLimit = 50
  const scrollPosition = window.scrollY // 500px
  const entirePageHeight = Math.max(
    body.scrollHeight,
    body.offsetHeight,
    html.clientHeight,
    html.scrollHeight,
    html.offsetHeight
  ) // 5000px
  const viewportHeight = window.innerHeight // 250 px
  const fitIntoViewport = (viewportHeight - wrapperElementHeight) / 2 // 250 - 100 = 150px /2 50px
  const realFitIntoViewport = fitIntoViewport > topAndBottomLimit ? fitIntoViewport : topAndBottomLimit // if 50 > 50 = 50px if 250 > 50 = 250 if 25 > 50 = 50
  const topOffset = realFitIntoViewport + scrollPosition // 50 + 500 = 550px from top
  const realTopOffset =
    topOffset + wrapperElementHeight > entirePageHeight - topAndBottomLimit
      ? entirePageHeight - wrapperElementHeight - topAndBottomLimit
      : topOffset // So it wont overflow if user is at the bottom

  scrollY.value = realTopOffset
}
</script>
<template>
  <template v-if="model">
    <div id="popUp" ref="wrapper" class="wholeWrapper" :style="{ top: `${scrollY}px` }">
      <slot/>
    </div>
    <button
      class="cover"
      @click="
        () => {
          model = false
        }
      "
    />
  </template>
</template>
<style scoped>
.exit {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 16px;
  height: 16px;
  border: none;
  background: none;
}

.exit img {
  width: 16px;
  height: 16px;
}

.wholeWrapper {
  position: absolute;
  top: 158px;
  left: 50%;
  transform: translateX(-50%);
  max-width: 480px;
  width: 100%;
  z-index: 999999;
  border-radius: 8px 20px 8px 20px;
  background-color: #fff;
  padding: 24px;
}

.cover {
  position: fixed;
  display: flex;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #000000a3;
  z-index: 9999;
}
</style>
